export const CONTENT = {
  modalHeader: 'Tilesets',
  retryMessage: 'Please try again',
  inserted: 'Inserted',
  created: 'Created',
  deleteButton: 'Delete',
  cancelButton: 'Cancel',
  insertButton: 'Insert tileset',
  errorMessage: 'Unable to retrieve tilesets.',
  searchPlaceholder: 'Search all tilesets',
  deleteSuccessToast: 'Journey tileset deleted!',
  deleteFailToast: 'Journey tileset could not be deleted.',
  insertedCountSingle: 'time',
  insertedCountPlural: 'times',
};
